import { render } from "./Instruction.vue?vue&type=template&id=66b5338e"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"

import "./Instruction.vue?vue&type=style&index=0&id=66b5338e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__